import React, {ReactNode} from 'react';
import {Wrapper, Title} from './styles';

type ScreenTitleProps = {
  title: string;
  rightContent?: ReactNode;
};

export function ScreenTitle({title, rightContent}: ScreenTitleProps) {
  return (
    <Wrapper>
      <Title>{title}</Title>
      {rightContent}
    </Wrapper>
  );
}
